import {call, put, takeLatest, cancel, takeEvery} from 'redux-saga/effects'
import * as action from 'actions'
import {
  CUSTOMERS_FEEDBACK_PAGE_REQUEST,
  CUSTOMERS_FEEDBACK_LIST_FEEDBACK_REQUEST,
  CUSTOMERS_FEEDBACK_CHANGE_DATE,
  CUSTOMERS_FEEDBACK_SUBMIT_REPLY_REQUEST,
  CUSTOMERS_FEEDBACK_MESSAGES_REQUEST,
  CUSTOMERS_FEEDBACK_RECEIPT_REQUEST,
  CUSTOMERS_FEEDBACK_ON_CLICK_ROW
} from 'actions/customers/feedback/constants'
import {
  LOGOUT
} from 'actions/constants'

import {
  listFeedbackRequest,
  setListFeedback,
  setFeedbackMessages,
  setReceiptFeedback,
  setCurrentPage,
  setTotalPage
} from 'actions/customers/feedback'
import { getFilteredDate } from 'api/get-filtered-date'
import moment from 'moment'
import {getTransactionDetail} from 'api/reports'
import {reset, initialize} from 'redux-form'
import {showPageLoadingSpinner} from 'actions/loadingSpinner'
import * as actNotif from 'actions/notifications'
import {getFeedbackMessages, submitReply, getCustomerFeedbacks} from 'api/customer-feedbacks'
import * as mpCustFeedback from 'mixpanel/customers/feedback'

function * fillSearchForm (startDate, endDate) {
  yield put(initialize('search', {date: {startDate, endDate}}))
}

export function * feedbackPageRequestFlow (request) {
  yield put(setListFeedback([]))
  mpCustFeedback.customerFeedbackStart()
  // will be set false by feedback request saga
  try {
    yield put(action.showProgressBar())
    yield put(showPageLoadingSpinner(true))
    // call date
    let filteredDate = yield call(getFilteredDate)
    let startDate = moment(filteredDate.data.start_date, 'YYYY-MM-DD')
    let endDate = moment(filteredDate.data.end_date, 'YYYY-MM-DD')
    // set calendar state
    yield call(fillSearchForm, startDate, endDate)
    let startDateFormatted = startDate.format('D/M/YYYY')
    let endDateFormatted = endDate.format('D/M/YYYY')
    yield put(listFeedbackRequest({start: startDateFormatted, end: endDateFormatted, page: 1}))
    $('#customer-feedback-detail').hide()
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(action.hideProgressBar())
  }
}

export function * getCustomerFeedbacksFlow (request) {
  try {
    yield put(action.showProgressBar())
    const {payload: {query, previousFeedback}} = request
    let startDate = query.start
    let endDate = query.end
    let page = query.page
    let feedbacksRes = yield call(getCustomerFeedbacks, {start: startDate, end: endDate, page: page})
    let resFeedbacks = feedbacksRes.data
    if (resFeedbacks) {
      let feedbacks
      if (previousFeedback) {
        feedbacks = previousFeedback.concat(resFeedbacks.results)
      } else {
        feedbacks = resFeedbacks.results
      }
      yield put(setCurrentPage(page))
      yield put(setTotalPage(resFeedbacks.total_pages))
      yield put(setListFeedback(feedbacks))
    }
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(showPageLoadingSpinner(false))
    yield put(action.hideProgressBar())
  }
}

export function * changeDateFeedbackFlow (request) {
  yield put(setListFeedback([]))
  // will be set false by feedback request saga
  yield put(showPageLoadingSpinner(true))
  let {payload} = request
  let {startDate, endDate} = payload
  let startDateFormatted = moment(startDate).format('D/M/YYYY')
  let endDateFormatted = moment(endDate).format('D/M/YYYY')
  yield put(listFeedbackRequest({
    start: startDateFormatted, end: endDateFormatted, page: 1
  }))
}

/**
 * TODO remove
 * @param request
 */
export function * getFeedbackMessagesFlow (request) {
  try {
    yield put(action.showProgressBar())
    yield put(showPageLoadingSpinner(true))
    let {payload} = request
    let {id} = payload
    let feedbackBusinessName = ''
    let feedbackMessagesRes = yield call(getFeedbackMessages, id)
    let feedbackMessages = feedbackMessagesRes.data
    if (feedbackMessages) {
      yield put(setFeedbackMessages(feedbackMessages))
      if (feedbackMessages.business_name.length > 12) {
        feedbackBusinessName = feedbackMessages.business_name.slice(0, 12) + '...- '
      } else {
        feedbackBusinessName = feedbackMessages.business_name.slice(0, 12) + ' - '
      }
      yield put(initialize('feedbackReplyForm', {
        feedbackfrom: feedbackMessages.feedback_from,
        comment: feedbackMessages.feedback_from === 'sms' ? feedbackBusinessName : '',
        business_name: feedbackBusinessName
      }))
    }
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(showPageLoadingSpinner(false))
    yield put(action.hideProgressBar())
  }
}

/**
 * TODO remove
 * @param request
 */
export function * getFeedbackReceiptFlow (request) {
  try {
    yield put(action.showProgressBar())
    yield put(showPageLoadingSpinner(true))
    let {payload} = request
    let {id} = payload
    let transactionDetail = yield call(getTransactionDetail, id)
    if (transactionDetail.data) {
      yield put(setReceiptFeedback(transactionDetail.data))
    }
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(showPageLoadingSpinner(false))
    yield put(action.hideProgressBar())
  }
}

export function * submitReplyRequestFlow (request) {
  let data = request.payload.data
  mpCustFeedback.customerFeedbackReply({feedback: data})
  try {
    yield put(action.showProgressBar())
    yield call(submitReply, data)
    let feedbackMessages = yield call(getFeedbackMessages, data.feedback_id)
    yield put(setFeedbackMessages(feedbackMessages.data))
    yield put(reset('feedbackReplyForm'))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(action.hideProgressBar())
  }
}

export function * onClickRowFlow (request) {
  const {payload: {feedback}} = request
  try {
    yield put(action.showProgressBar())
    yield put(showPageLoadingSpinner(true))
    let transactionDetail = yield call(getTransactionDetail, feedback.payment_id)
    if (transactionDetail.data) {
      yield put(setReceiptFeedback(transactionDetail.data))
    }
    let feedbackBusinessName = ''
    let feedbackMessagesRes = yield call(getFeedbackMessages, feedback.id)
    let feedbackMessages = feedbackMessagesRes.data
    if (feedbackMessages) {
      yield put(setFeedbackMessages(feedbackMessages))
      if (feedbackMessages.business_name.length > 12) {
        feedbackBusinessName = feedbackMessages.business_name.slice(0, 12) + '...- '
      } else {
        feedbackBusinessName = feedbackMessages.business_name.slice(0, 12) + ' - '
      }
      yield put(initialize('feedbackReplyForm', {
        feedbackfrom: feedbackMessages.feedback_from,
        comment: feedbackMessages.feedback_from === 'sms' ? feedbackBusinessName : '',
        business_name: feedbackBusinessName
      }))
    }
    mpCustFeedback.customerFeedbackSelect({
      feedback, transaction: transactionDetail.data, feedbackMessages
    })
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(showPageLoadingSpinner(false))
    yield put(action.hideProgressBar())
  }
}

export function * cancelAction (cancelledTasks, request) {
  yield cancel(...cancelledTasks)
}

export default function * customersFeedbackSaga () {
  const feedbackPage = yield takeLatest(CUSTOMERS_FEEDBACK_PAGE_REQUEST, feedbackPageRequestFlow)
  const feedbackList = yield takeLatest(CUSTOMERS_FEEDBACK_LIST_FEEDBACK_REQUEST, getCustomerFeedbacksFlow)
  const changeDate = yield takeLatest(CUSTOMERS_FEEDBACK_CHANGE_DATE, changeDateFeedbackFlow)
  const feedbackMessages = yield takeLatest(CUSTOMERS_FEEDBACK_MESSAGES_REQUEST, getFeedbackMessagesFlow)
  const feedbackReceipt = yield takeLatest(CUSTOMERS_FEEDBACK_RECEIPT_REQUEST, getFeedbackReceiptFlow)
  yield takeEvery(CUSTOMERS_FEEDBACK_SUBMIT_REPLY_REQUEST, submitReplyRequestFlow)
  yield takeLatest(CUSTOMERS_FEEDBACK_ON_CLICK_ROW, onClickRowFlow)

  // don't cancel submit reply to prevent unsent data
  yield takeEvery(LOGOUT, cancelAction, [feedbackPage, feedbackList, changeDate, feedbackMessages, feedbackReceipt])
}



// WEBPACK FOOTER //
// ./app/sagas/customers/feedback.js